<template lang="pug">
  .bloquinho.clearfix
    .simbolo
      .icone: slot(name="icone")
      .sigla: slot(name="sigla")
    .texto
      slot(name="texto")
</template>

<style lang="scss">
  // Vars
  $icone-bg-color: $color-green-light;
  $icone-color: $color-blue-dark;

  // Style
  .bloquinho {

    > .simbolo {
      text-align: center;
      color: $icone-color;

      > .icone {
        color: $icone-color;
        width: 125px;
        height: 125px;
        display: flex;
        margin: 0 auto 15px auto;
        align-items: center;
        justify-content: center;
        border-radius: 7px;
        background-color: $icone-bg-color;
        > .fa { font-size: 80px; }
      }

      > .sigla {
        margin-bottom: 10px;
        font-weight: 800;
      }

    }

    @include media(">=desktop") {
      &.-responsive {
        .simbolo { float: left; }
        .texto { padding-left: 150px; }
      }
    }

    // Estilos

    &.--yellow-hover:hover {
      > .texto { color: $text-default-color }
      > .simbolo > .icone { color: $color-yellow-accent }
      > .simbolo > .icone { background-color: $color-yellow-primary }
    }

    &.--blue-hover:hover {
      > .texto { color: $text-default-color }
      > .simbolo > .icone { color: $color-blue-accent }
      > .simbolo > .icone { background-color: $color-blue-primary }
    }

    &.--green-hover:hover {
      > .texto { color: $text-default-color }
      > .simbolo > .icone { color: $color-green-accent }
      > .simbolo > .icone { background-color: $color-green-primary }
    }

    &.--orange-hover:hover {
      > .texto { color: $text-default-color }
      > .simbolo > .icone { color: $color-orange-accent }
      > .simbolo > .icone { background-color: $color-orange-primary }
    }

    &.--wine-hover:hover {
      > .texto { color: $text-default-color }
      > .simbolo > .icone { color: $color-wine-accent }
      > .simbolo > .icone { background-color: $color-wine-primary }
    }

    &.--turqueza-hover:hover {
      > .texto { color: $text-default-color }
      > .simbolo > .icone
      > .texto { color: $color-turqueza-accent }
      > .simbolo > .icone { background-color: $color-turqueza-primary }
    }

    &.--grey-hover:hover {
      > .texto { color: $text-default-color }
      > .simbolo > .icone { color: $color-grey-accent }
      > .simbolo > .icone { background-color: $color-grey-primary }
    }

  }
</style>

<script>

export default {
  name: 'bloquinho'
}
</script>



// WEBPACK FOOTER //
// Bloquinho.vue?268dedce